import { Event } from 'client/types/event';
import { List } from 'client/types/common';
import * as types from './types';

export interface EventState {
    readonly data: List<Event>;
    readonly isLoading: boolean;
    readonly error?: string;
}

const initialState: EventState = {
    data: { rows: [], meta: {} },
    isLoading: false,
};

function fetchEvents(state: EventState, action: types.FetchEventsRequest) {
    return {
        ...state,
        data: {
            ...state.data,
            meta: {
                ...state.data.meta,
                pageNumber: action.payload,
            },
        },
        isLoading: true,
        error: undefined,
    };
}

function fetchEventsSuccess(state: EventState, action: types.FetchEventsSuccess) {
    const { meta, rows: actualRows } = action.payload;

    // Если загружаем не первую страницу, то не удаляем предыдущие события
    const rows = meta.pageNumber === 1 ?
        actualRows :
        [...state.data.rows, ...actualRows];

    return {
        ...state,
        data: { meta, rows },
        isLoading: false,
        error: undefined,
    };
}

function fetchEventsError(state: EventState, action: types.FetchEventsError) {
    const { payload } = action;
    const errorMessage = payload.message;

    return {
        ...state,
        data: initialState.data,
        isLoading: false,
        error: errorMessage,
    };
}

export default function eventReducer(
    state = initialState,
    action: types.EventsActionTypes
): EventState {
    switch (action.type) {
    case types.FETCH_EVENTS_REQUEST:
        return fetchEvents(state, action);
    case types.FETCH_EVENTS_SUCCESS:
        return fetchEventsSuccess(state, action);
    case types.FETCH_EVENTS_ERROR:
        return fetchEventsError(state, action);
    default:
        return state;
    }
}
